import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"

export const query = graphql`
  fragment ArticleContentEmbedCodeFields on DatoCmsArticleBlockEmbedCode {
    id
    model {
      apiKey
    }
    embedCode
  }
`

import { ArticleContentEmbedCodeFieldsFragment } from "../../../../graphql-types"

const sanitize = (code: string): string => {
  const domTree = new DOMParser().parseFromString(code, "text/html")

  const iframeElement = domTree.querySelector("iframe")

  if (!iframeElement) {
    return "Invalid embed code."
  }

  let isValidUrl = false
  ;[
    "https://open.spotify.com/",
    "https://embed.acast.com/",
    "https://w.soundcloud.com/",
  ].forEach(url => {
    if (
      (iframeElement as HTMLIFrameElement).attributes
        .getNamedItem("src")
        .value.indexOf(url) === 0
    ) {
      isValidUrl = true
    }
  })

  if (!isValidUrl) {
    return "Invalid embed source."
  }

  return iframeElement.outerHTML
}

const ArticleBlockEmbedCode: React.FC<ArticleContentEmbedCodeFieldsFragment> = props => {
  const [embedCode, setEmbedCode] = useState("")
  useEffect(() => {
    setEmbedCode(sanitize(props.embedCode))
    return () => {
      setEmbedCode("")
    }
  }, [props.embedCode])

  return (
    props.embedCode && (
      <div
        className="c-article-block-embed-code"
        dangerouslySetInnerHTML={{
          __html: embedCode,
        }}
      />
    )
  )
}

export default ArticleBlockEmbedCode
